export class Properties {
    heading: string = "Pharmacy Walk-In";
    inputSearchDataSource: any = {
        data: {
            "datasource": {
                "application": "patient-registration",
                "resource": "patient",
                "query_id": "GET_PAGE"
            },
            "fields": [
                "displayName",
                "telecom",
                "uhId",
                "gender"
            ],
            "fixLabel": {
                "popup": {
                    "title": "Add Patient",
                    "size": "lg",
                    "redirectLink": "/ot/surgery_request/add"
                },
                "text": "Register New Patient?",
                "layout_type": "simple",
                "resource": "pre_registration",
                "action": "add",
                "application": "patient-registration"
            }
        }
    };
    patientData:object={  //// This is for walkin banner datasource
        "selector": "app-patient-layout", /// patient-layout
        "jsonName": "banner_pharmacyPrescriptionLink",
        "expandable": false,
        "datasource": {
            "application": "patient-registration",
            "resource": "patient",
            "query_id": "GET_PATIENT_BY_ID_OR_UHID",
            "args": "deposit_required:true,patient_id:!!!key!!!"
        }
        // "AvailableCashNetAmount": {
        //     "application": "payment",
        //     "resource": "user_collection_detail",
        //     "query_id": "GET_CASH_COLLECTION",
        //     "supporting_banner": {
        //         "fields": [
        //             {
        //                 "heading": "field.label.available_cash_Amount",
        //                 "order": 1,
        //                 "sortable": true,
        //                 "showheading": true,
        //                 "name": "netAmount",
        //                  "banner_color_text": true,
        //                 "class_conditions": [
        //             {
        //                  "expression": "item['netAmount']!=''",
        //                 "class": "_bold-highlight-color"
        //             }
        //         ]
        //             }
        //         ]
        //     }
        // }
    };
    approve_patientData:object={  //// This is for walkin banner datasource
        "selector": "app-patient-layout",
        "jsonName": "banner_pharmacyPrescriptionLink",
        "expandable": false,
        "datasource": {
            "application": "billing",
            "resource": "authority_clearance",
            "query_id": "GET_PHARMACY_ORDER"
        }
        //  "AvailableCashNetAmount": {
        //     "application": "payment",
        //     "resource": "user_collection_detail",
        //     "query_id": "GET_CASH_COLLECTION",
        //     "supporting_banner": {
        //         "fields": [
        //             {
        //                 "heading": "field.label.available_cash_Amount",
        //                 "order": 1,
        //                 "sortable": true,
        //                 "showheading": true,
        //                 "name": "netAmount",
        //                 "banner_color_text": true,
        //                 "class_conditions": [
        //                 {
        //                  "expression": "item['netAmount']!=''",
        //                   "class": "_bold-highlight-color"
        //                  }
        //                 ]
        //                }
        //              ]
        //     }
        // }
    };
    patientData_IP_pharmacy:object={  //// This is for new Order in IP pharmacy
        "selector": "emr-patient-layout",
        "jsonName": "banner_pharmacy_ip_order_new_order",
        "expandable": false,
        "PharmacyScreenIPAmount":{
            "application": "billing",
            "resource": "billing_details",
            "query_id": "GET_PHARMACY_NET_FOR_PATIENTS",
            "supporting_banner": {
                "fields": [
                    {
                        "className": "col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3 fix p-2",
                        "heading": "field.label.IP_Pharmacy_Deposit_Amount",
                        "order": 2,
                        "sortable": true,
                        "name": "pharmacy_deposit_available",
                        "showheading": true
                    },
                    {
                        "className": "col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3 fix p-2",
                        "heading": "field.label.IP_Pharmacy_Issue_Net_Amount",
                        "order": 1,
                        "sortable": true,
                        "name": "total_amount",
                        "showheading": true
                    },
                    {
                        "className": "col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3 fix p-2",
                        "heading": "field.label.Due_Amount",
                        "order": 3,
                        "sortable": true,
                        "name": "pharmacy_due",
                        "banner_color_text": true,
                        "class_conditions": [
                            {
                                "expression": "item['pharmacy_due'] != undefined && item['pharmacy_due'] > 0",
                                "class": "_pb-due-amount-red"
                            }
                        ],
                        "showheading": true
                    },
                    {
                        "className": "col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3 fix p-2",
                        "heading": "field.label.pharmacy_refund",
                        "order": 4,
                        "sortable": true,
                        "name": "pharmacy_refund",
                        "showheading": true
                    }
                ]
            }
        },
        "datasource": {
            "application": "adt",
            "resource": "encounter",
            "query_id": "GET_BY_ID"
        }
    };
    approve_patientData_IP_pharmacy: object = {  //// This is for new Order in IP pharmacy
        "selector": "emr-patient-layout",
        "jsonName": "ip_pharmacy_approve_order",
        "expandable": false,
        "datasource": {
            "application": "billing",
            "resource": "authority_clearance",
            "query_id": "GET_IP_PHARMACY_SPLIT_ORDER"
        }
    };
    patientDataForOpSale:object={ //  this is for OP orders banner
        "jsonName": "banner_pharmacyLink",
        "selector": "app-patient-layout",
        "datasource": {
            "application": "pharmacy",
            "resource": "medicationOrder", 
            "query_id": "GET_BY_ID" 
        }
        //  "AvailableCashNetAmount": {
        //     "application": "payment",
        //     "resource": "user_collection_detail",
        //     "query_id": "GET_CASH_COLLECTION",
        //     "supporting_banner": {
        //         "fields": [
        //             {
        //                 "heading": "field.label.available_cash_Amount",
        //                 "order": 1,
        //                 "sortable": true,
        //                 "showheading": true,
        //                 "name": "netAmount",
        //                 "banner_color_text": true,
        //                 "class_conditions": [
        //                 {
        //                  "expression": "item['netAmount']!=''",
        //                   "class": "_bold-highlight-color"
        //                  }
        //                 ]
        //                }
        //              ]
        //     }
        // }
    };
    patientDataForOpDraft:object={
        "selector": "app-patient-layout",
        "datasource": {
            "application": "pharmacy",
            "resource": "medicationIssue",
            "query_id": "GET_BY_ID"
        },
        "jsonName": "banner_pharmacy"
    };
    pharmacyDraft:object={
        "selector": "app-patient-layout",
        "jsonName": "banner_pharmacyLink",
        "datasource": {
            "application": "pharmacy",
            "resource": "medicationIssue",
            "query_id": "GET_BY_ID"
        }
    };
    pharmacyWalkinDraft:object={
        "selector": "emr-patient-layout",
        "jsonName": "walkinDraftBanner",
        "datasource": {
            "application": "pharmacy",
            "resource": "medicationIssue",
            "query_id": "GET_BY_ID"
        }
    };
    showBanner:boolean;
    preRegistration:object={
        "resource": "pre_registration",
        "application": "patient-registration",
        "action": "add",
        "delegate": true,
        "popup": {
            "header": "Patient Detail",
            "size": "md",
            "form": "pre_registration"
        }
    };
    patVerification:object={
            "selector": "app-patient-layout",
            "datasource": {
              "application": "pharmacy",
              "resource": "medicationIssue",
              "query_id": "get_ip_order_patient_data"
            },
            "jsonName": "banner_ip_pharmacy_order"
          
    };
   
    getSchemeDataSource(patientInfo,payer_id){
        if (patientInfo && payer_id){
            return {
                application: "facility-management",
                resource: "scheme_detail",
                query_id: "GET_SCHEME_DETAILS",
                args: `uhId:${this.getpatientId(patientInfo)},patient_type:${patientInfo.patientType ? patientInfo.patientType:'OP'},gender:${patientInfo.patient_gender},payer:${payer_id}`,
            }
        }else{
            console.log("proper args not provided");
        }
    }
    getBatches(itemCode,patientType){
        if (itemCode){
            return {
                application: "inventory-management",
                resource: "stock",
                query_id: "GET_BATCH_BY_ITEM",
                args: `itemCode:${itemCode},patient_type:${patientType?patientType:'OP'}`,
            }
        }else{
            console.log("Batch not loaded");
        }
    }
    getpatientId(obj) {
        if (obj && obj.hasOwnProperty("uhId")) {
            return obj.uhId;
        } else if (obj && obj.hasOwnProperty("preRegistrationNo")) {
            return obj.preRegistrationNo;
        }
    }
    showPayment:boolean=false;
    payMentData:any;
    freeze:boolean;
    disabled:boolean;
    currentPayment:any;
    sumOftotalServices:number;
    mainData:any;
    _current:any={};
    THRESHOLD_VALUE : 6000;
}

